import React from "react";
import "./ConstruccionCivil.css"; 
import electricidadImg from "../assets/images/electricidad.jpg";
import pdfMalla from "../assets/docs/electricidad.pdf";
import { FaBolt, FaDownload } from "react-icons/fa";

const ElectricidadIndustrial = () => {
  return (
    <section className="carrera-detalle">
      {/*  Banner superior */}
      <div
        className="carrera-hero-modern"
        style={{ backgroundImage: `url(${electricidadImg})` }}
      >
        <div className="carrera-hero-overlay">
          <h1 className="fw-bold">Electricidad Industrial</h1>
          <p>
            Formamos profesionales técnicos en energía, mantenimiento y
            automatización industrial.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container my-5">
        <div className="row g-4">
    
          <div className="col-lg-8">
            <div className="info-card p-4 shadow-sm rounded-4 bg-white">
              <h3 className="text-primary fw-bold mb-3">
                <FaBolt className="me-2" />
                TÍTULO: PROFESIONAL TÉCNICO EN ELECTRICIDAD INDUSTRIAL
              </h3>

              <h5 className="fw-bold text-primary mt-4">COMPETENCIA GENERAL</h5>
              <p>
                Planificar, organizar, proyectar, supervisar y ejecutar el
                montaje e instalación, mantenimiento y automatización de líneas
                de energía, tableros, instrumentos, máquinas y controles
                eléctricos, siguiendo normas técnicas de seguridad y control de
                calidad establecidas.
              </p>

              <h5 className="fw-bold text-primary mt-4">
                CAMPOS DE ACCIÓN EN LOS QUE SE INSERTAN LOS EGRESADOS
              </h5>
              <p>
                El profesional técnico de Electricidad Industrial se desempeña
                en el mercado laboral peruano y extranjero en sectores
                productivos, tanto en empresas privadas como en instituciones
                públicas, y puede generar su propia empresa.
              </p>
              <ul>
                <li>Gerente de Micro y Pequeña Empresa</li>
                <li>Jefe de Soporte Técnico</li>
                <li>Supervisor de Planta</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">PUESTOS DE TRABAJO</h5>
              <ul>
                <li>Supervisor de planta</li>
              </ul>

              <h5 className="fw-bold text-primary mt-4">
                SALIDA HACIA OTROS ESTUDIOS
              </h5>
              <ul>
                <li>Ingeniería Eléctrica</li>
                <li>Ingeniería Mecánica-Eléctrica</li>
                <li>Ingeniería Electrónica</li>
                <li>Ingeniería Industrial</li>
              </ul>
            </div>
          </div>

          {/* Panel lateral */}
          <div className="col-lg-4">
            <div className="sidebar-card p-4 rounded-4 shadow-sm text-center bg-white">
              <img
                src={electricidadImg}
                alt="Electricidad Industrial"
                className="img-fluid rounded-3 mb-3"
              />
              <a
                href={pdfMalla}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-download w-100"
              >
                <FaDownload className="me-2" /> Descargar Malla Curricular 2024
                (PDF)
              </a>
              <div className="mt-4 text-start">
                <h6 className="text-primary fw-bold">DURACIÓN</h6>
                <p className="mb-2">
                  Seis semestres equivalentes a tres años académicos.
                </p>
                <h6 className="text-primary fw-bold">TURNOS DE ESTUDIO</h6>
                <p className="mb-0">Diurno - 8:00 a.m. a 1:00 p.m.</p>
                <p className="mb-0">Nocturno - 6:00 p.m. a 10:20 p.m.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ElectricidadIndustrial;
